import script from "./PasswordLogin.vue?vue&type=script&setup=true&lang=ts"
export * from "./PasswordLogin.vue?vue&type=script&setup=true&lang=ts"

import "./PasswordLogin.vue?vue&type=style&index=0&id=758edabe&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-758edabe"]])

export default __exports__